<template>
    <el-container class="user-journey">
        <div
            class="uj-progress"
            v-if="!pagination.index == 0 && !flags.step4 && pagination.index !== 10"
        >
            <el-progress
                :text-inside="true"
                :show-text="false"
                color="#3b6bbf"
                :stroke-width="8"
                :percentage="userJourneyProgress"
            ></el-progress>
        </div>
        <el-header height="auto">
            <div class="common-nav" v-if="!flags.step1 && !flags.step4">
                <span class="skip" @click="paginationNext" v-if="pagination.index == 10">Skip</span>
                <a
                    @click="paginationPrevious"
                    v-if="pagination.index != 1 && pagination.index != 2 && pagination.index != 6 && pagination.index !== 10"
                >{{$t('UJ.back')}}</a>
                <h4 v-if="pagination.index !== 10">{{$t('UJ.currentStep', {currentSection})}}</h4>
                <!-- <h1>{{pageInfo[pagination.index].title}}</h1> -->
                <h1 v-html="pageInfo[pagination.index].title"></h1>
                <p v-html="pageInfo[pagination.index].desc"></p>
                <!-- <p>{{pageInfo[pagination.index].desc}}</p> -->
            </div>
        </el-header>

        <el-main class="uj-main">
            <el-card class="box-card" :class="{section10 : pagination.index == 10 }">
                <UJStart
                    v-if="flags.step1"
                    @paginationNext="paginationNext"
                    :ppb="commonParams.ppbApi"
                />
                <UJStep1
                    v-if="flags.step2"
                    @paginationNext="broadcastNextSection"
                    :pageIndex="pagination.index"
                    :nationalities="commonParams.nationalities"
                    :currencies="commonParams.currencies"
                    :requestParams="requestParams"
                    :defaultSetting="defaultSetting"
                    :collectModels.sync="collectModels"
                />
                <UJStep2
                    v-if="flags.step3"
                    @paginationNext="broadcastNextSection"
                    @code="getInvitationCode"
                    :pageIndex="pagination.index"
                    :requestParams="requestParams"
                    :defaultSetting="defaultSetting"
                    :collectModels.sync="collectModels"
                />
                <UJSuccess
                    v-if="flags.step4"
                    :nextMethod="paginationNext"
                    :pageIndex="pagination.index"
                />
            </el-card>
            <div
                class="background-profile hidden-md-and-down"
                v-if="pagination.index == 0 || pagination.index == 11"
            >
                <img
                    src="../../../../website_20/static/img/UJ/UJ-background-profile@2x.png"
                    alt="User Journey Profile"
                />
            </div>

            <div class="invitation-group" v-if="pagination.index == 10">
                <el-button @click="submitCode" class="code-btn">{{$t('UJ.section10.use_code')}}</el-button>
                <div class="apply-card" :class="{section10: pagination.index == 10}">
                    <h1>{{$t("UJ.section10.apply_title")}}</h1>
                    <div class="inline-group">
                        <p>{{$t("UJ.section10.apply_desc")}}</p>
                        <el-button class="apply-btn" @click="applyCode">{{$t("UJ.section10.apply")}}</el-button>
                    </div>
                </div>
            </div>
        </el-main>

        <el-footer height="auto">
            <a
                class="next-btn"
                v-if="!flags.step1 && !flags.step4 && pagination.index !== 10 "
                @click="paginationNext"
            ></a>
        </el-footer>
    </el-container>
</template>


<script>
import { Message } from "element-ui";
import UJStart from "@/components/userJourney/UJStart";
import UJStep1 from "@/components/userJourney/UJStep1";
import UJStep2 from "@/components/userJourney/UJStep2";
import UJSuccess from "@/components/userJourney/UJSuccess";

let loading;

export default {
    name: "userJourneyContainer",
    data() {
        const $t = this.$t.bind(this);
        return {
            invitation_code: "",
            requestParams: {},
            currentSection: 1,
            userJourneyProgress: 0,
            pagination: {
                index: 0
            },
            flags: {
                step1: true,
                step2: false,
                step3: false,
                step4: false
            },
            nextSection: false,
            pageInfo: [
                {
                    title: "",
                    desc: ""
                },
                {
                    title: $t("UJ.section1.title"),
                    desc: $t("UJ.section1.desc")
                },
                {
                    title: $t("UJ.section2.title"),
                    desc: $t("UJ.section2.desc")
                },
                {
                    title: $t("UJ.section3.title"),
                    desc: $t("UJ.section3.desc")
                },
                {
                    title: $t("UJ.section4.title"),
                    desc: $t("UJ.section4.desc")
                },
                {
                    title: $t("UJ.section5.title"),
                    desc: $t("UJ.section5.desc")
                },
                {
                    title: $t("UJ.section6.title"),
                    desc: $t("UJ.section6.desc")
                },
                {
                    title: $t("UJ.section7.title"),
                    desc: $t("UJ.section7.desc")
                },
                {
                    title: $t("UJ.section8.title"),
                    desc: $t("UJ.section8.desc")
                },
                {
                    title: $t("UJ.section9.title"),
                    desc: $t("UJ.section9.desc")
                },
                {
                    title: $t("UJ.section10.title"),
                    desc: $t("UJ.section10.desc")
                },
                {
                    title: "",
                    desc: ""
                }
            ],

            commonParams: {
                userId: this.$root.userId,
                token: this.$root.token,
                ppbApi: this.$root.ppbApi,
                nationalities: [],
                currencies: [],
                areas: []
            },

            defaultSetting: {},

            collectModels: {
                profileForm: {
                    first_name: "",
                    last_name: "",
                    birth: "1980-01-01",
                    gender: "",
                    cityResidence: "",
                    nationality: "",
                    currency: ""
                },
                investment_interests: "",
                area_interests: [],
                investments: [],
                budgetForm: {},
                retirement_annual_expenses_type: "Comfortable",
                retirement_annual_expenses: 1500,
                portfolio_breakdown: 0,
                real_estate_target: 0,
                net_worth_range: ""
            }
        };
    },

    beforeMount() {
        this.requestParams = {
            getNationalities: `${this.commonParams.ppbApi}api/geo/countries/`,
            useCode: `${this.commonParams.ppbApi}api/vipcode/upgrade/`,
            applyCode: `${this.commonParams.ppbApi}api/vipcode/request/`,
            getUser: `${this.commonParams.ppbApi}api/user`,
            putUser: `${this.commonParams.ppbApi}api/user`,
            patchSaving: `${this.commonParams.ppbApi}api/savings/`,
            getDefSaving: `${this.commonParams.ppbApi}api/savings/defaults/`,
            getJourney: `${this.commonParams.ppbApi}api/savings/cities-rates/?journey=1`,
            getCurrency: `${this.commonParams.ppbApi}api/currency`,

            requestConfig: {
                headers: {
                    Authorization: `Token ${this.commonParams.token}`
                }
            }
        };

        if (this.$root.cookie.acreage != "en") {
            this.requestParams.requestConfig.headers["Accept-Language"] =
                "zh-Hans";
        }

        this.initialData();
    },
    mounted() {
        this.userJourneyProgress = 0;
    },

    methods: {
        initialView(resp) {
            if (
                resp.data.retirement_completed &&
                resp.data.property_purpose_completed
            ) {
                this.flags.step1 = false;
                this.flags.step2 = false;
                this.flags.step3 = false;
                this.flags.step4 = true;
                this.pagination.index = 11;
                this.currentSection = 3;
            } else if (resp.data.property_purpose_completed) {
                this.flags.step1 = false;
                this.flags.step2 = false;
                this.flags.step3 = true;
                this.flags.step4 = false;
                this.pagination.index = 6;
                this.currentSection = 2;
            } else if (resp.data.profile_completed) {
                this.flags.step1 = false;
                this.flags.step2 = true;
                this.flags.step3 = false;
                this.flags.step4 = false;
                this.pagination.index = 2;
                this.currentSection = 1;
            } else {
                this.flags.step1 = false;
                this.flags.step2 = true;
                this.flags.step3 = false;
                this.flags.step4 = false;
                this.pagination.index = 1;
                this.currentSection = 1;
            }

            this.userJourneyProgress = 10 * this.pagination.index;

            // get newest net worth range
            if (this.pagination.index >= 1 && this.pagination.index <= 6) {
                this.getDefault();
            }
        },

        initialData() {
            if (this.$router.currentRoute.query.index == 1) {
                this.flags.step1 = false;
                this.flags.step2 = true;
                this.flags.step3 = false;
                this.flags.step4 = false;
            }

            if (this.commonParams.userId) {
                loading = this.$loading({
                    lock: true,
                    target: ".el-table",
                    text: "Loading...",
                    spinner: "el-icon-loading",
                    color: "#3b6bbf",
                    background: "rgba(255, 255, 255, 0.8)"
                });
                this.patchSaving();
                this.getNationalities();
                this.getCurrency();
            }
        },

        // get flags
        patchSaving() {
            let requestConfig = this.requestParams.requestConfig;
            requestConfig.headers["Content-Type"] = "application/json";
            this.$http
                .patch(this.requestParams.patchSaving, {}, requestConfig)
                .then(resp => {
                    this.initialView(resp);
                    loading.close();
                });
        },

        getDefault() {
            this.$http
                .get(
                    this.requestParams.getDefSaving,
                    this.requestParams.requestConfig
                )
                .then(resp => {
                    this.defaultSetting = resp.data;
                });
        },

        getNationalities() {
            this.$http
                .get(
                    this.requestParams.getNationalities,
                    this.requestParams.requestConfig
                )
                .then(resp => {
                    resp.data.forEach(it => {
                        this.commonParams.nationalities.push(it);
                    });
                });
        },

        getCurrency() {
            this.$http
                .get(
                    this.requestParams.getCurrency,
                    this.requestParams.requestConfig
                )
                .then(resp => {
                    resp.data.forEach(it => {
                        this.commonParams.currencies.push(it);
                    });
                });
        },

        broadcastNextSection(data) {
            this.nextSection = data.next;
        },

        checkAllFill(ele) {
            let list = Object.values(ele);
            let allTrue = list.every(val => {
                return val != "";
            });
            if (allTrue) {
                this.nextSection = true;
            } else {
                this.nextSection = false;
            }
        },

        paginationNext() {
            switch (this.pagination.index) {
                case 0:
                    this.nextSection = true;
                    break;
                case 1:
                    this.checkAllFill(this.collectModels.profileForm);
                    break;
                case 2:
                    if (this.collectModels.investment_interests != "") {
                        this.nextSection = true;
                    }
                    break;
                case 3:
                    if (
                        this.collectModels.area_interests.length <= 3 &&
                        this.collectModels.area_interests.length >= 1
                    ) {
                        this.nextSection = true;
                    }
                    break;
                case 4:
                    if (this.collectModels.investments.length >= 3) {
                        this.nextSection = true;
                    }
                    break;
                case 5:
                    if (this.collectModels.investments.length >= 3) {
                        this.nextSection = true;
                    }
                    break;
                case 6:
                    if (
                        this.collectModels.retirement_annual_expenses_type !=
                            "" &&
                        this.collectModels.retirement_annual_expenses > 100
                    ) {
                        this.nextSection = true;
                    } else {
                        this.triggerMessage("error", {
                            message:
                                "Retirement annual expenses is not correct!"
                        });
                    }
                    break;
                case 7:
                    if (
                        typeof this.collectModels.portfolio_breakdown ==
                        "number"
                    ) {
                        this.nextSection = true;
                    }
                    break;
                case 8:
                    if (this.collectModels.real_estate_target != "") {
                        this.nextSection = true;
                    }
                    break;
                case 9:
                    if (this.collectModels.net_worth_range.length == 1) {
                        this.nextSection = true;
                    }
                    break;
                case 10:
                    this.nextSection = true;
                    break;

                default:
                    this.nextSection = false;
                    break;
            }

            if (
                this.pagination.index == 1 ||
                this.pagination.index == 5 ||
                this.pagination.index == 9
            ) {
                if (this.nextSection) {
                    this.nextSection = false;
                    this.submitData();
                    return;
                }
            }
            this.paginationCheck();
        },

        paginationCheck() {
            if (this.nextSection) {
                this.paginationCtrl(1);
                this.nextSection = false;
            } else {
                switch (this.pagination.index) {
                    case 1:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error1")
                        });
                        break;
                    case 2:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error2")
                        });
                        break;
                    case 3:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error3")
                        });
                        break;
                    case 4:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error4")
                        });
                        break;
                    case 5:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error5")
                        });
                        break;
                    case 6:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error6")
                        });
                        break;
                    case 7:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error7")
                        });
                        break;
                    case 8:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error8")
                        });
                        break;
                    case 9:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error9")
                        });
                    case 10:
                        this.triggerMessage("error", {
                            message: this.$t("UJ.errorFeedBack.error9")
                        });
                        break;
                }
            }
        },

        paginationPrevious() {
            this.paginationCtrl(-1);
        },

        paginationCtrl(num) {
            this.scrollToTop();
            if (this.pagination.index == 11) {
                return;
            }
            this.pagination.index += num;

            this.changeFlags(this.pagination.index);

            this.userJourneyProgress = 10 * this.pagination.index;
        },

        submitData() {
            let collectModels = {},
                method = "";
            let index = this.pagination.index;

            if (index == 1) {
                collectModels = this.collectModels.profileForm;
                method = "put";
            } else if (index == 5) {
                let investments = [];
                method = "patch";
                this.collectModels.investments.forEach(it => {
                    investments.push({
                        city: it.id,
                        value: it.average_price
                    });
                });
                collectModels = {
                    area_interests: this.collectModels.area_interests,
                    investment_interests: this.collectModels
                        .investment_interests,
                    investments: investments
                };
            } else if (index == 9) {
                method = "patch";
                collectModels = {
                    portfolio_breakdown: this.collectModels.portfolio_breakdown,
                    retirement_annual_expenses: this.collectModels
                        .retirement_annual_expenses,
                    retirement_annual_expenses_type: this.collectModels
                        .retirement_annual_expenses_type,
                    real_estate_target: this.collectModels.real_estate_target,
                    net_worth_range: this.collectModels.net_worth_range
                };
            }

            let url = "";
            if (method == "put") {
                url = `${this.requestParams.putUser}/${this.commonParams.userId}`;
            } else if (method == "patch") {
                url = `${this.requestParams.patchSaving}`;
            }

            this.$http[method](
                url,
                collectModels,
                this.requestParams.requestConfig
            ).then(resp => {
                if (this.pagination.index == 9) {
                } else {
                    this.initialView(resp);
                }

                this.nextSection = true;

                if (resp.data.profile_completed && this.pagination.index == 2) {
                    this.pagination.index = 1;
                } else if (
                    resp.data.property_purpose_completed &&
                    this.pagination.index == 6
                ) {
                    this.pagination.index = 5;
                }

                this.paginationCheck();

                this.defaultSetting.currency_code = resp.data.currency_code;
                this.defaultSetting.currency_symbol = resp.data.currency_symbol;

                if (resp.status != 200) {
                    this.triggerMessage("error", {
                        message: "Somethings are broken. Try to refresh page"
                    });
                }
            });
        },

        changeFlags(index) {
            if (index == 11) {
                this.flags.step4 = true;
                this.flags.step3 = false;
            } else if (index > 5) {
                this.flags.step4 = false;
                this.flags.step3 = true;
                this.flags.step2 = false;
                this.currentSection = 3;
            } else if (index > 1) {
                this.flags.step3 = false;
                this.flags.step2 = true;
                this.flags.step1 = false;
                this.currentSection = 2;
            } else if (index == 1) {
                this.flags.step3 = false;
                this.flags.step2 = true;
                this.flags.step1 = false;
                this.currentSection = 1;
            } else if (index == 0) {
                this.flags.step1 = true;
                this.flags.step2 = false;
                this.currentSection = 1;
            }
        },

        scrollToTop() {
            window.scroll({
                top: 0,
                behavior: "smooth"
            });
        },
        broadcastPagination(index) {
            this.pagination.index = index;
        },
        triggerMessage(type, options) {
            return Message[type](options);
        },

        submitCode() {
            if (this.invitation_code) {
                this.$http
                    .post(
                        `${this.requestParams.useCode}`,
                        { code: this.invitation_code },
                        this.requestParams.requestConfig
                    )
                    .then(resp => {
                        if (resp.status == 204) {
                            this.triggerMessage("success", {
                                message: this.$t("UJ.section10.successMsg")
                            });
                            this.nextSection = true;
                            this.paginationCheck();
                        }
                    })
                    .catch(error => {
                        if (error.status == 400) {
                            this.triggerMessage("error", {
                                message: this.$t("UJ.section10.codeExist")
                            });
                        }
                    });
            } else {
                this.triggerMessage("error", {
                    message: this.$t("UJ.section10.inputIsEmpty")
                });
            }
        },

        applyCode() {
            this.$http
                .post(
                    `${this.requestParams.applyCode}`,
                    {},
                    this.requestParams.requestConfig
                )
                .then(resp => {
                    if (resp.status == 204) {
                        this.triggerMessage("success", {
                            message: this.$t("UJ.section10.applyMsg")
                        });
                        this.nextSection = true;
                        this.paginationCheck();
                    }
                })
                .catch(error => {
                    if (error.status == 400) {
                        this.triggerMessage("error", {
                            message: this.$t("UJ.section10.errorMsg")
                        });
                    }
                });
        },

        getInvitationCode(data) {
            this.invitation_code = data;
        }
    },

    watch: {
        commonParams: {}
    },

    components: {
        UJStart,
        UJStep1,
        UJStep2,
        UJSuccess
    }
};
</script>

<style lang="scss">
.user-journey {
    width: 100vw;
    min-height: 100vh;
}
.user-journey {
    width: 100%;
    background-color: #deecff;
    .uj-progress {
        .el-progress-bar__outer {
            background-color: #ced8de;
        }
        .el-progress-bar__outer,
        .el-progress-bar__inner {
            border-radius: 0;
        }
    }
}
.el-header {
    min-height: 60px;
}
.uj-main {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    .invitation-group {
        width: 100%;
        text-align: center;
        .code-btn {
            margin-top: 25px;
            margin-bottom: 48px;
            width: 180px;
            height: 44px;
            border-radius: 4px;
            color: var(--white);
            background-color: var(--windows-blue);
        }
        .apply-card {
            padding: 16px 17px;
            border-radius: 6px;
            background-color: #203862;
            h1 {
                font-family: GothamMedium;
                font-size: 14px;
                font-weight: 500;
                color: var(--white);
                margin-bottom: 10px;
            }
            p {
                font-family: GothamBook;
                font-size: 12px;
                line-height: 1.5;
                margin-bottom: 10px;
                text-align: center;
                color: var(--white);
            }
            .apply-btn {
                padding: 0;
                text-align: center;
                font-size: 14px;
                width: 100px;
                height: 32px;
                border-radius: 4px;
                background-color: var(--white);
                color: #203862;
            }
        }
    }
}

.section10 {
    width: 100%;
    max-width: 560px;
    margin: 0 auto;
}

.box-card {
    border: 0;
    border-radius: 8px;
    box-shadow: 0 2px 10px 0 rgba(155, 155, 155, 0.5);
    background-color: var(--white);
    .el-card__body {
        padding: 0;
    }
}
.common-nav {
    margin-top: 20px;
    position: relative;
    a {
        display: block;
        width: 100%;
        padding-left: 25px;
        margin-bottom: 37px;
        font-family: GothamBook;
        font-size: 16px;
        color: var(--windows-blue);
        position: relative;
        &:before {
            content: "";
            display: inline-block;
            width: 19px;
            height: 12px;
            position: absolute;
            left: 0;
            top: 5px;
            background-repeat: no-repeat;
            background-image: url("../../../../website_20/static/img/icon-back-blue.svg");
            background-size: contain;
        }
    }
    h4 {
        font-family: GothamMedium;
        font-size: 13px;
        font-weight: 500;
        color: var(--windows-blue);
    }
    h1 {
        font-family: GothamBold;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0.7px;
        color: #333333;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    p {
        margin-top: 10px;
        font-family: GothamBook;
        font-size: 14px;
        line-height: 1.71;
        color: var(--brownish-grey);
        span {
            font-family: GothamMedium;
        }
    }
    .skip {
        cursor: pointer;
        text-align: right;
        margin: 60px auto 0;
        display: inherit;
        font-family: GothamMedium;
        font-size: 14px;
        margin-bottom: 10px;
        letter-spacing: 0.5px;
        color: var(--windows-blue);
    }
}
.basic-uj {
    padding: 20px 23px;
    h4 {
        font-family: GothamMedium;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.5px;
        color: var(--windows-blue);
        margin-top: 20px;
        margin-bottom: 15px;
    }
    h1 {
        font-family: GothamBold;
        font-size: 24px;
        font-weight: bold;
        line-height: 1.17;
        color: #4a4a4a;
        margin-bottom: 10px;
    }
    .desc {
        font-family: GothamBook;
        font-size: 14px;
        line-height: 1.57;
        color: var(--brownish-grey);
    }
    .basic-list {
        li {
            margin-bottom: 33px;
            padding-left: 40px;
            margin-top: 34px;
        }
        h2 {
            font-family: GothamMedium;
            font-size: 16px;
            font-weight: 500;
            line-height: 1;
            letter-spacing: 0.3px;
            color: #333333;
            margin-bottom: 5px;
        }
        p {
            font-family: GothamBook;
            font-size: 14px;
            line-height: 1.57;
            color: var(--brownish-grey);
        }
    }
    .checked-list {
        li {
            position: relative;
            &:before {
                content: "";
                position: absolute;
                display: inline-block;
                width: 20px;
                height: 20px;
                left: 0;
                top: 0;
                background-repeat: no-repeat;
                background-image: url("../../../../website_20/static/img/icon-checkmark@2x.png");
                background-size: cover;
            }
        }
    }

    .primary-btn {
        margin-top: 52px;
        .solid-btn {
            box-shadow: none;
            border: 0;
            width: 180px;
            font-size: 15px;
            font-family: GothamMedium;
            height: 44px;
            line-height: 44px;
            padding: 0;
            text-align: center;
            background-color: var(--windows-blue);
        }
        .little-hint {
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1.17;
            color: var(--brownish-grey);
            margin-top: 20px;
            margin-bottom: 17px;
        }
        a.login {
            display: inline-block;
            width: 100%;
            margin-top: 20px;
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1.17;
            color: var(--windows-blue);
            margin-top: 10px;
        }
    }
}
.border-list {
    .el-form-item {
        // display: flex;
        // justify-content: space-between;
        margin: 0;
        padding: 20px;
        border-bottom: 1px solid #e0e7ff;
        &:last-child {
            border-bottom: 0;
        }
        .el-form-item__label {
            font-family: GothamBook;
            font-size: 16px;
            color: #1b2125;
            padding-right: 0;
        }
        .el-form-item__content {
            // overflow: hidden;
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 154px;
            }
            .el-input__inner {
                border: 0;
                text-align: right;
                font-family: GothamMedium;
                font-size: 16px;
                font-weight: 500;
                color: #1b2125;
            }
            .el-select__caret {
                color: #666666;
                font-weight: bold;
            }
        }
    }
}
.checkPic-list {
    padding: 20px;
    .checkPic-w100-item,
    .checkPic-w50-item,
    .checkPic-w33-item {
        height: 90px;
        display: inline-block;
        width: 100%;
        margin-bottom: 3px;
        border-radius: 3px;
        background-color: rgba(0, 0, 0, 0.3);
        overflow: hidden;
        position: relative;
        img {
            position: absolute;
            top: 0;
            display: block;
            z-index: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            cursor: pointer;
            top: 0;
            &.checked {
                background-color: rgba(59, 107, 191, 0.8);
                &:after {
                    content: "";
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    right: 18px;
                    top: 18px;
                    background: url("../../../../website_20/static/img/icon-checkmark-white.svg")
                        no-repeat;
                }
            }
            h4 {
                cursor: pointer;
                display: flex;
                height: 100%;
                align-items: center;
                justify-content: center;
                text-shadow: 1px 2px 6px rgba(0, 0, 0, 0.5);
                font-family: "OpenSans-Bold";
                font-size: 13px;
                font-weight: bold;
                text-align: center;
                color: var(--white);
            }
            p {
                margin-top: 2px;
                text-shadow: 1px 2px 7px rgba(0, 0, 0, 0.5);
                font-family: OpenSans;
                font-size: 13px;
                text-align: center;
                color: var(--white);
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -14px;
                height: 36px;
                line-height: 1;
                width: 100%;
            }
        }
    }
    .checkPic-w50-item {
        width: 49%;
        .mask.checked:after {
            right: 8px;
            top: 8px;
        }

        &:nth-child(2n) {
            margin-left: 3px;
        }
        &:nth-child(2n-1) {
            margin-right: 3px;
        }
    }
    .checkPic-w33-item {
        width: 32.6%;
        height: 60px;
        .mask.checked:after {
            content: unset;
        }
        .mask {
            h4 {
                align-items: flex-start;
                padding-top: 10px;
            }
        }

        &:nth-child(3n-1) {
            margin-left: 3px;
            margin-right: 3px;
        }
    }
}
.budget-list {
    .budget-city {
        height: 24px;
        line-height: 24px;
        width: 100%;
        font-family: GothamBook;
        font-size: 14px;
        color: #1b2125;
        text-align: left;
        span {
            font-family: GothamMedium;
        }
    }
    .el-form-item {
        padding: 15px 27px;
        .el-form-item__content .budget-price {
            width: 100%;
            display: flex;
            justify-content: space-between;
            height: 24px;
            line-height: 24px;
            font-size: 14px;
            color: #1b2125;
            font-family: GothamMedium;
            .budget-currency {
                width: 80px;
                text-align: left;
            }
            .el-input__inner {
                text-align: left;
                height: 24px;
                line-height: 24px;
                padding: 0;
                padding-left: 10px;
            }
        }
    }
}
.retirement-group {
    .retirement-list {
        display: flex;
        padding: 20px 17px 25px;
        border-bottom: solid 1px #e1e4e8;
        li {
            width: 33%;
            height: 75px;
            border-radius: 4px;
            border: solid 1px #e6e8ed;
            background-color: var(--white);
            position: relative;

            &.checked {
                border: solid 1.5px #447ef6;
                background-color: #f2f7ff;
                &:before {
                    content: "";
                    position: absolute;
                    display: none;
                    top: 12px;
                    right: 12px;
                    width: 20px;
                    height: 21px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-image: url("../../../../website_20/static/img/UJ/icon-checkmark-blueBGC.svg");
                }
                h4 {
                    color: var(--windows-blue);
                }
            }

            &.option {
                cursor: pointer;
                &:after {
                    content: "";
                    position: absolute;
                    display: inline-block;
                    bottom: 28px;
                    width: 100%;
                    height: 30px;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
            &.option0:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-modest.svg");
            }
            &.option1:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-comfortable.svg");
            }
            &.option2:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-premium.svg");
            }

            &:nth-child(2) {
                margin: 0 8px;
            }
            h4 {
                position: absolute;
                bottom: 13px;
                font-family: GothamMedium;
                font-size: 11px;
                display: inline-block;
                width: 100%;
                text-align: center;
                line-height: 0.91;
                text-align: center;
                color: #4a4a4a;
            }
        }
    }
    .expenses-monthly {
        padding: 14px 17px 10px;
        h4 {
            font-family: GothamBook;
            font-size: 14px;
            color: #1b2125;
            padding-bottom: 15px;
        }
        .number-input {
            display: flex;
            align-items: center;
            position: relative;
            .expenses-currency {
                position: absolute;
                left: 16px;
                top: 13px;
                height: 16px;
                line-height: 16px;
                font-family: GothamMedium;
                font-size: 16px;
                z-index: 1;
                color: #1b2125;
            }
            .el-input {
                width: 70%;
                margin-right: 6px;
                .el-input__inner {
                    padding: 0;
                    padding-left: 88px;
                    border: 0;
                    height: 42px;
                    border-radius: 4px;
                    font-family: GothamMedium;
                    font-size: 16px;
                    color: #1b2125;
                    background-color: #f2f7ff;
                }
            }
            .expenses-per-month {
                height: 24px;
                line-height: 24px;
                font-family: GothamBook;
                font-size: 14px;
                color: #1b2125;
            }
        }
    }
}
.card-list {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 22px;
    .card-group {
        width: 100%;
    }
    .card-detail {
        display: none;
    }
    .card-item {
        cursor: pointer;
        width: 100%;
        min-height: 135px;
        border-radius: 4px;
        border: solid 1.5px #e6e8ed;
        padding: 16px 16px 16px 92px;
        margin-bottom: 10px;
        position: relative;
        &.selected {
            border: solid 1.5px #447ef6;
            background-color: #f2f7ff;
            border-bottom-width: 3px;
        }

        &.uj-pipe1,
        &.uj-pipe2,
        &.uj-pipe3,
        &.uj-pipe4 {
            &:after {
                content: "";
                display: inline-block;
                width: 55px;
                height: 55px;
                position: absolute;
                top: 20px;
                left: 20px;
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
        &.uj-pipe1:after {
            background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie1.svg");
        }
        &.uj-pipe2:after {
            background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie2.svg");
        }
        &.uj-pipe3:after {
            background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie3.svg");
        }
        &.uj-pipe4:after {
            background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie4.svg");
        }
        h4 {
            font-family: GothamMedium;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.33;
            color: #333;
            margin-bottom: 5px;
            text-align: center;
        }
        p {
            font-family: GothamBook;
            font-size: 10px;
            line-height: 1.6;
            color: #4a4a4a;
        }
        .card-points {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-top: 10px;
            li {
                min-width: 50%;
                display: inline-block;
                padding-left: 12px;
                position: relative;
                font-family: GothamBook;
                font-size: 10px;
                line-height: 1.6;
                color: #4a4a4a;
                &:nth-child(2n) {
                    padding-left: 27px;
                    &:after {
                        left: 15px;
                    }
                }
                &:after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    top: 4px;
                    left: 0px;
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                }
                &.percent1:after {
                    background-color: #052991;
                }
                &.percent2:after {
                    background-color: #9fdbfc;
                }
                &.percent3:after {
                    background-color: #447ef6;
                }
                &.percent4:after {
                    background-color: #7076c8;
                }
            }
        }
    }
}
.slider-card {
    padding: 20px 20px 60px;
    .title {
        .el-input {
            display: none;
        }
    }
    .adjust-slider {
        & > h4 {
            height: 18px;
            font-family: GothamMedium;
            font-size: 18px;
            font-weight: 500;
            text-align: center;
            color: #447ef6;
        }
    }
    .block {
        position: relative;
        .real-estate {
            display: block;
            position: absolute;
            font-family: GothamMedium;
            width: 60px;
            top: 30px;
            left: 13px;
            z-index: 1;
            font-size: 13px;
            color: var(--white);
        }
        .el-slider__input {
            display: none;
        }

        .el-slider__runway {
            height: 60px;
            width: 100%;
        }
        .el-slider__bar {
            background-color: rgb(68, 126, 246);
            height: 60px;
        }
        .el-slider__button {
            border: 3px solid #447ef6;
        }
        .range-price {
            display: flex;
            justify-content: space-between;
            margin-bottom: 40px;
            span {
                font-family: GothamBook;
                font-size: 14px;
                letter-spacing: 0.5px;
                text-align: center;
                color: #8e8e8e;
            }
        }
    }
    .title,
    .little-hint {
        height: 24px;
        font-family: GothamBook;
        font-size: 14px;
        line-height: 24px;
        color: #1b2125;
    }
    .title {
        margin-bottom: 44px;
    }
    .little-hint {
        text-align: center;
        color: var(--brownish-grey);
        &.small {
            display: none;
        }
    }
}
.check-list {
    li {
        height: 60px;
        line-height: 60px;
        font-family: GothamBold;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: var(--brownish-grey);
        border-bottom: 0.6px solid #e0e7ff;
        position: relative;
        padding: 0 25px;
        &:last-child {
            border-bottom: 0;
        }
        &.selected {
            background-color: #447ef6;
            color: var(--white);
            &:after {
                content: "";
                display: inline-block;
                width: 24px;
                height: 24px;
                position: absolute;
                top: 18px;
                right: 25px;
                background: url("../../../../website_20/static/img/icon-checkmark-white.svg")
                    no-repeat;
            }
        }
    }
}
.el-footer {
    min-height: 78px;
    .next-btn {
        display: block;
        margin: 5px auto 25px;
        width: 48px;
        height: 48px;
        background-image: url("../../../../website_20/static/img/icon-uj-arrow.svg");
        background-repeat: no-repeat;
        background-size: cover;
    }
}

@media (min-width: 768px) {
    .uj-main {
        margin: 0 auto;
        // width: 560px;
        .invitation-group {
            .apply-card {
                padding: 16px 22px;
                h1 {
                    text-align: left;
                }
                .inline-group {
                    display: flex;
                    align-items: center;
                    p {
                        margin-bottom: 0;
                        text-align: left;
                    }
                }
            }
        }
    }
    .basic-uj {
        padding: 45px 54px;
        width: 560px;
        .primary-btn {
            .little-hint {
                display: inline-block;
                margin-left: 20px;
            }
        }
    }
    .basic-section {
        width: 560px;
        &.section7 {
            width: 700px;
        }
    }
    .common-nav {
        h1 {
            font-size: 26px;
        }
        h4,
        h1,
        p {
            width: 560px;
            margin: 0 auto;
        }
        h1 {
            margin: 10px auto;
            line-height: 1.38;
        }
        .skip {
            width: 560px;
        }
    }
    .el-footer .next-btn {
        margin-bottom: 90px;
    }

    .checkPic-list {
        padding: 35px 14px 40px;
        .checkPic-w100-item {
            .mask h4 {
                font-size: 14px;
            }
        }
        .checkPic-w50-item {
            height: 106px;
            width: 31.8%;
            margin-bottom: 10px;
            &:nth-child(2n-1) {
                margin-right: 0;
            }
            &:nth-child(2n) {
                margin-left: 0;
            }
            &:nth-child(3n-1) {
                margin-left: 12px;
                margin-right: 12px;
            }
        }
        .checkPic-w33-item {
            height: 106px;
            width: 31.8%;
            margin-bottom: 10px;
            &:nth-child(2n-1) {
                margin-right: 0;
            }
            &:nth-child(2n) {
                margin-left: 0;
            }
            &:nth-child(3n-1) {
                margin-left: 12px;
                margin-right: 12px;
            }
            .mask {
                padding: 0;
                h4 {
                    align-items: center;
                    padding: 0;
                }
                p {
                    bottom: 8px;
                }
            }
        }
    }
    .border-list.budget-list {
        .el-form-item__content {
            .budget-wrapper {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .budget-price {
                    .el-input {
                        width: 120px;
                    }
                }
            }
        }
    }
    .retirement-group {
        .retirement-list {
            padding: 45px;
            li.option {
                height: 118px;
                &:after {
                    height: 36px;
                    bottom: 55px;
                }
            }
            li.checked:before {
                display: inline-block;
            }
            li h4 {
                bottom: 27px;
                font-size: 14px;
            }
        }
        .expenses-monthly {
            padding: 14px 45px 28px;
            .number-input {
                .el-input {
                    width: 214px;
                }
            }
        }
    }
    .card-list {
        .card-group {
            display: flex;
            margin-bottom: 50px;
        }
        .card-detail {
            display: block;
            width: 100%;
            border-top: 1px solid #e6e8ed;
            padding: 26px 23px 16px;
            padding-left: 202px;
            position: relative;
            &:after {
                content: "";
                display: inline-block;
                width: 108px;
                height: 108px;
                position: absolute;
                left: 23px;
                top: 26px;
                background-repeat: no-repeat;
                background-size: contain;
            }
            &.uj-pipe1:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie1.svg");
            }
            &.uj-pipe2:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie2.svg");
            }
            &.uj-pipe3:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie3.svg");
            }
            &.uj-pipe4:after {
                background-image: url("../../../../website_20/static/img/UJ/icon-uj-pie4.svg");
            }
            h4 {
                font-family: GothamMedium;
                font-size: 14px;
                font-weight: 500;
                line-height: 1.14;
                color: #4a4a4a;
                margin-bottom: 5px;
            }
            p {
                font-family: GothamBook;
                font-size: 12px;
                line-height: 2;
                color: var(--brownish-grey);
            }
            .card-points {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                li {
                    min-width: 50%;
                    display: inline-block;
                    padding-left: 12px;
                    position: relative;
                    font-family: GothamBook;
                    font-size: 10px;
                    line-height: 1.6;
                    color: #4a4a4a;
                    font-size: 12px;
                    margin-bottom: 15px;
                    &:nth-child(2n) {
                        padding-left: 27px;
                        &:after {
                            left: 15px;
                        }
                    }
                    &:after {
                        content: "";
                        display: inline-block;
                        position: absolute;
                        top: 4px;
                        left: 0px;
                        width: 7px;
                        height: 7px;
                        border-radius: 50%;
                    }
                    &.percent1:after {
                        background-color: #052991;
                    }
                    &.percent2:after {
                        background-color: #9fdbfc;
                    }
                    &.percent3:after {
                        background-color: #447ef6;
                    }
                    &.percent4:after {
                        background-color: #7076c8;
                    }
                }
            }
        }
        .card-item {
            width: 155px;
            padding: 9px 0 6px;
            margin-left: 10px;
            &:first-child {
                margin-left: 0;
            }
            h4 {
                font-size: 10.9px;
                padding: 0 16px;
            }
            p {
                min-height: 53px;
                padding: 0 16px;
                font-size: 9.3px;
                margin-top: 70px;
                padding-top: 10px;
                border-top: 1px solid #e6e8ed;
            }
            .card-points {
                display: none;
            }
            &.uj-pipe1,
            &.uj-pipe2,
            &.uj-pipe3,
            &.uj-pipe4 {
                &:after {
                    top: 31px;
                    left: 50%;
                    transform: translate(-50%);
                }
            }
        }
    }

    .slider-card {
        .title {
            position: relative;
            .el-input {
                display: block;
                float: unset;
                margin-top: 0;
                position: absolute;
                right: 0px;
                top: -3px;
                width: 134px;
            }
            .el-input__inner {
                padding: 0;
                border: 0;
                color: #333;
                background-color: #f2f7ff;
                font-family: GothamMedium;
                font-size: 20px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                width: 134px;
            }
        }
        .el-input__inner {
            padding: 0;
            border: 0;
            color: #333;
            background-color: #f2f7ff;
            font-family: GothamMedium;
            font-size: 20px;
            text-align: center;
        }
        .adjust-slider {
            h4 {
                display: none;
            }
            .el-slider__input {
                display: block;
                float: unset;
                margin-top: 0;
                position: absolute;
                right: 0px;
                top: -70px;
                width: 185px;
            }
            .el-slider__runway {
                margin-right: 0;
            }
            .el-input-number__decrease,
            .el-input-number__increase {
                display: none;
                border-color: var(--windows-blue);
            }
        }
    }
}

@media (min-width: 1024px) {
    .common-nav {
        a {
            margin-bottom: 0;
        }
        h4 {
            // margin-top: -17px;
        }
    }

    .uj-main {
        padding-bottom: 45px;
        display: flex;
        align-items: center;
        margin: 0 auto;
        .invitation-group {
            // margin-top: -20%;
        }
    }
    .background-profile {
        margin-left: 76px;
        width: 418px;
        height: 559px;
        display: flex;
        align-items: flex-end;
        img {
            width: 100%;
            height: 457px;
        }
    }
    .basic-uj {
        h4 {
            margin-top: 0;
        }
    }
    .common-nav {
        a {
            margin-bottom: 0;
        }
        h1 {
            margin-top: 10px;
            font-size: 26px;
            margin-bottom: 10px;
        }
    }
    .border-list {
        .el-form-item {
            padding-left: 40px;
            padding-right: 40px;
        }
    }
    .checkPic-list {
        padding: 35px 45px;
        .checkPic-w100-item {
            height: 105px;
        }
        .checkPic-w50-item,
        .checkPic-w33-item {
            width: 23.7%;
            &:nth-child(2n) {
                margin-left: 0;
            }
            &:nth-child(3n-1) {
                margin-left: 0;
                margin-right: 0;
            }
            // 2,6  3,7
            &:nth-child(4n-2) {
                margin-left: 12px;
                margin-right: 12px;
            }
            &:nth-child(4n-1) {
                margin-right: 12px;
            }
        }
    }
    .basic-section {
        &.moreWidth {
            width: 800px;
        }
        &.section7 {
            width: 922px;
        }
    }
    .budget-list {
        .el-form-item {
            padding: 27px 27px;
            .el-form-item__content .budget-price {
                font-size: 16px;
                margin-top: 8px;
                justify-content: left;
            }
        }
        .budget-city {
            font-size: 16px;
        }
    }
    .card-list {
        padding: 40px 37px;
        .card-item {
            width: 200px;
            height: 210px;
            padding-top: 14px;
            margin-left: 16px;
            h4 {
                text-align: center;
                margin-bottom: 13px;
                font-size: 14px;
            }
            &.uj-pipe1,
            &.uj-pipe2,
            &.uj-pipe3,
            &.uj-pipe4 {
                &:after {
                    width: 78px;
                    height: 78px;
                    top: 41px;
                }
            }
            p {
                margin-top: 100px;
                font-size: 12px;
            }
        }
        .card-detail {
            .card-points {
                li {
                    width: 210px;
                    min-width: unset;
                }
            }
        }
    }

    .slider-card {
        padding: 40px 45px;
        .adjust-slider {
            .el-slider__input {
                width: 134px;
                right: 0;
                .el-input-number__decrease,
                .el-input-number__increase {
                    display: none;
                }
                .el-input {
                    input {
                        padding: 0;
                        width: 100%;
                    }
                }
            }
        }
    }
    .check-list {
        li {
            height: 80px;
            line-height: 80px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/userJourney/userJourneyContainer.vue